import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-polyglot'
import StockHistorical from '../../../components/dossierHistorical/stock/StockHistorical'
import stockDossierActions from '../../../actions/dossier/stockDossier'
import commentsActions from '../../../actions/dossier/common/comments'
import commonHeaderActions from '../../../actions/dossier/common/commonHeader'
import { openDocumentManagementModal as openDocumentModal } from '../../../actions/dossier/common/documentManagementModal'
import { closeAddOrEditDocumentModal } from '../../../actions/dossier/common/documentHistoricalEditionModal'
import scrollerActions from '../../../actions/commons/scroller'
import buttonsHeaderActions from '../../../actions/dossier/common/buttonsHeader'
import buttonsSidebarActions from '../../../actions/dossier/common/buttonsSidebar'
import { fetchFilteredRelatedDossier } from '../../../actions/dossier/common/dossierRelatedDossiers'
import { saveSelectedDocuments } from '../../../actions/dossier/sales'
import clientActions from '../../../actions/dossier/common/client'
import vehicleActions from '../../../actions/dossier/common/vehicle'
import { fecthFamily, fetchSameLevelOusCombo, fetchRatingCombo } from '../../../actions/combos/combos'
import TrackingContainer from '../../tracking/trackingContainer'
import { registerLastAccess } from '../../../actions/dossier/common/lastAccessDossier'

export function mapStateToProps (state) {
  return {
    dossier: state.stockDossier,
    combos: state.combos,
    windowWidth: state.windowDimensions.width,
    statusHeaderHeight: state.statusHeader.height,
    activeTab: state.buttonsHeader.activeTab,
    buttonsHeaderHeight: state.buttonsHeader.height,
    activeSection: state.buttonsSidebar.activeSection,
    relatedDossiersOrderBy: state.dossierRelatedDossiers.orderby,
    vehicleProps: state.vehicle
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      ...stockDossierActions,
      ...commentsActions,
      ...clientActions,
      ...commonHeaderActions,
      ...buttonsHeaderActions,
      ...buttonsSidebarActions,
      ...scrollerActions,
      ...vehicleActions,
      closeAddOrEditDocumentModal,
      fetchFilteredRelatedDossier,
      openDocumentModal,
      saveSelectedDocuments,
      fecthFamily,
      fetchSameLevelOusCombo,
      fetchRatingCombo,
      registerLastAccess
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(translate()(TrackingContainer(StockHistorical, true)))
